import ManageCustomPermissionsLandingPage from "./ManageCustomPermissionsLandingPage";

const ManageCustomPermissions = () => {
  return <ManageCustomPermissionsLandingPage />;
};

export default ManageCustomPermissions;
